import React from 'react'
interface CommonTableTextProps {
  text: string
  style?: React.CSSProperties
}

const CommonTableText: React.FC<CommonTableTextProps> = ({ text, style }) => {
  return (
    <span
      title={text}
      style={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '100%',
        ...style
      }}>
      {text}
    </span>
  )
}

export default CommonTableText
